import React from 'react'
import StatusLight from '../../../components/Status/StatusLight'

export default () => {
  return <StatusLight status='success' size='16px' />
}
